module.exports = __webpack_public_path__ + "assets/HKNova-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Medium.ttf
// module id = 135
// module chunks = 0